import { render } from "./indexEn.vue?vue&type=template&id=036eef08&scoped=true"
import script from "./indexEn.vue?vue&type=script&lang=js"
export * from "./indexEn.vue?vue&type=script&lang=js"

import "./indexEn.vue?vue&type=style&index=0&id=036eef08&lang=scss&scoped=true"

import exportComponent from "E:\\code\\test\\clink_home-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036eef08"]])

export default __exports__